/* STAMINA: Upcart dynamic shipping via existing Upcart elements, not injected React children. */
(function(){
'use strict';
if(window.__staminaUpcartCompact)return;
window.__staminaUpcartCompact=true;
var country=String(window.staminaUpcartCountry||(window.Shopify&&window.Shopify.country)||'DE').toUpperCase();
var shippingGoal=(country==='DE'||country==='AT')?5000:8000;
var root=null,watcher=null,timer=null,loading=false;
function money(cents){
 var currency=(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active)||'EUR';
 try{return new Intl.NumberFormat(document.documentElement.lang||'de-DE',{style:'currency',currency:currency}).format(cents/100)}
 catch(e){return (cents/100).toFixed(2).replace('.',',')+' €'}
}
function draw(total){
 if(!root||!root.isConnected)return;
 var announcement=root.querySelector('.upcart-announcement,.drawer__header--shipping-announcement');
 var footer=root.querySelector('.upcart-footer,[data-upcart-footer]');
 var remaining=Math.max(0,shippingGoal-total);
 var pct=Math.max(0,Math.min(100,Math.round(total/shippingGoal*100)));
 if(announcement){
  announcement.setAttribute('data-st-shipping',remaining?'Noch '+money(remaining)+' bis zum kostenlosen Versand':'✓ Kostenloser Versand erreicht');
  announcement.style.setProperty('--st-upcart-pct',pct+'%');
 }
 if(footer)footer.setAttribute('data-st-total','ZWISCHENSUMME · '+money(total));
}
function update(){
 if(!root||!root.isConnected||loading)return;
 loading=true;
 var prefix=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
 fetch(prefix+'cart.js',{credentials:'same-origin',cache:'no-store'})
  .then(function(res){if(!res.ok)throw Error('Cart unavailable');return res.json()})
  .then(function(cart){draw(Number(cart.total_price||0))})
  .catch(function(){})
  .finally(function(){loading=false});
}
function schedule(){
 if(timer)clearTimeout(timer);
 timer=setTimeout(update,550);
}
function attach(found){
 root=found;
 watcher=new MutationObserver(function(records){
  if(records.some(function(m){
   var node=m.target.nodeType===1?m.target:m.target.parentElement;
   return node&&node.closest&&node.closest('.upcart-products-section,.upcart-footer,.upcart-announcement,.drawer__header--shipping-announcement,[data-upcart-footer]');
  }))schedule();
 });
 watcher.observe(root,{childList:true,subtree:true});
 root.addEventListener('click',function(e){
  if(e.target.closest('.upcart-product-quantity-plus,.upcart-product-quantity-minus,.upcart-upsells-button,[class*="TrashButton"]'))setTimeout(schedule,400);
 });
 schedule();
}
function init(){
 var found=document.getElementById('upCart');
 if(found){attach(found);return}
 var discovery=new MutationObserver(function(){
  var node=document.getElementById('upCart');
  if(node){discovery.disconnect();attach(node)}
 });
 discovery.observe(document.body,{childList:true,subtree:true});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
else init();
})();